import {getVectorDistance} from "./index";

const getClosestObject = (point, objLeft, objRight) => {
	const distanceLeft = getVectorDistance(point, [...objLeft]);
	const distanceRight = getVectorDistance(point, [...objRight]);

	return (distanceLeft < distanceRight) ? objLeft : objRight;
};
export default getClosestObject;